export * from './types';
export {
  DegreeCardDetailed,
  DEGREE_CARD_DEFAULT_TRUSTED_PARTNER_TEXT,
  type DegreeCardDetailedProps,
  type DegreeCardDetailedDataPoint,
  type DegreeCardDetailedDetailItem,
  DEGREE_CARD_DETAIL_LIST_FORMAT,
  type DegreeCardDetailListFormat,
} from './DegreeCardDetailed';
export {
  degreeCardDetailedVariants,
  type DegreeCardDetailedVariantProps,
} from './degree-card-detailed.variants';
